import { debounce } from 'lodash';
import translations from '@/mixins/translations';
import helpers from '../services/helpers';

const pager = {
  mixins: [translations],
  data() {
    return {
      pageSizeList: [12, 24, 48, 100],
      // how much items in pagination will be shown before and after current page
      numberOfPages: 3,
      actionName: '',
      searchField: '',
      searchConfig: {
        sortBy: '',
        isSortAscending: false,
        pageSize: localStorage.getItem('pageSize')
          ? parseInt(localStorage.getItem('pageSize'), 10)
          : 12,
        quickSearch: '',
        page: 1,
      },
      sortFields: [
        {
          id: 1,
          field: null,
          isSortAscending: false,
          label: 'defaultSort',
        },
        {
          id: 2,
          field: 'createdDate',
          isSortAscending: true,
          label: 'sortByDateOldest',
        },
        {
          id: 3,
          field: 'createdDate',
          isSortAscending: false,
          label: 'sortByDateNewest',
        },
        {
          id: 4,
          field: 'vpc',
          isSortAscending: true,
          label: 'sortByPriceLow',
        },
        {
          id: 5,
          field: 'vpc',
          isSortAscending: false,
          label: 'sortByPriceHigh',
        },
      ],
    };
  },
  computed: {
    pager() {
      return this.$store.getters.getPager;
    },
    pages() {
      const { currentPage, totalPages } = this.pager;
      const { numberOfPages } = this;

      const min = currentPage - numberOfPages >= 1 ? currentPage - numberOfPages : 1;
      const max = currentPage + numberOfPages <= totalPages
        ? currentPage + numberOfPages
        : totalPages;

      return helpers.generateRange(min, max);
    },
    effectivePageSize() {
      if (this.paginationProps && this.paginationProps.pageSize) {
        return this.paginationProps.pageSize;
      }
      if (this.searchConfig && this.searchConfig.pageSize) {
        return this.searchConfig.pageSize;
      }
      const stored = parseInt(localStorage.getItem('pageSize'), 10);
      return stored > 0 ? stored : 12;
    },
    toResults() {
      const pageSize = this.effectivePageSize;
      return this.pager.totalItems < this.pager.currentPage * pageSize
        ? this.pager.totalItems
        : this.pager.currentPage * pageSize;
    },
    fromResults() {
      const pageSize = this.effectivePageSize;
      return this.pager.currentPage === 1 ? 1 : (this.pager.currentPage - 1) * pageSize + 1;
    },
    nextDisabled() {
      return this.pager.currentPage === this.pager.totalPages;
    },
    prevDisabled() {
      return this.pager.currentPage === 1;
    },
    showPagination() {
      return this.pages.length > 1;
    },
    paginationResultsTitle() {
      return this.showPagination
        ? this.translations.pagingResults
          .replace('{fromResults}', this.fromResults)
          .replace('{toResults}', this.toResults)
          .replace('{totalItems}', this.pager.totalItems)
        : '';
    },
  },
  methods: {
    handleNextPage() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (!this.nextDisabled) {
        this.searchConfig.page += 1;
        this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
      }
    },
    handlePreviousPage() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (!this.prevDisabled) {
        this.searchConfig.page -= 1;
        this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
      }
    },
    goToPage(number) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (number === this.pager.currentPage) return;
      this.searchConfig.page = number;
      this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
    },
    handleSort(field) {
      this.searchConfig.sortBy = field.field;
      this.searchConfig.isSortAscending = field.isSortAscending;
      this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
    },
    isSortAsc(field) {
      return this.searchConfig.isSortAscending && this.searchConfig.sortBy === field;
    },
    isSortDesc(field) {
      return !this.searchConfig.isSortAscending && this.searchConfig.sortBy === field;
    },
    resetFilters() {
      let searchConfig = {
        ...this.searchConfig,
        ...this.paginationProps,
      };

      // Reset filters
      this.searchField = '';
      searchConfig = {
        ...searchConfig,
        sortBy: 'createdDate',
        isSortAscending: false,
        pageSize: 10,
        quickSearch: '',
        page: 1,
      };

      // Update data in component
      this.$store.dispatch(this.actionName, searchConfig);
    },
    changePageSize(pageSize) {
      localStorage.setItem('pageSize', pageSize);
      this.searchConfig.page = 1;
      this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
      this.goToPage(1);
      this.$router.replace({
        query: {
          page: 1,
          search: this.$route.query.search,
        },
      }).catch(() => {});
    },
    debounceInput: debounce(function search() {
      this.searchField = this.searchField.trim();
      this.searchConfig.quickSearch = this.searchField;
      this.$store.dispatch(this.actionName, this.searchConfig);
    }, 300),
  },
};

export default pager;
